export enum MeasureReason {
  ExcessiveAbsences = 1,
  Other = 2,
  NotYetEarliestLevel = 3,
}
